<div
  class="flex flex-col items-start justify-center rounded-2xl gap-1 w-full"
  [style.padding]="padding()"
  [style.backgroundColor]="backgroundColor()"
>
  <div class="flex gap-3 items-center justify-start">
    @let totalExists = total() !== null && total() !== undefined;

    @if (current() !== null && current() !== undefined) {
      <div class="flex items-center justify-start gap-1">
        <span class="font-medium" [style.fontSize]="currentFontSize()" [style.lineHeight]="currentFontSize()">
          {{ current()! | numberSuffix }}
        </span>

        @if (unit() && !totalExists) {
          <span class="text-xs">{{ unit() }}</span>
        }
      </div>
    }

    @if (totalExists) {
      <div class="flex items-center justify-start gap-1">
        <div class="flex items-center justify-start gap-3">
          <span class="self-end" [style.fontSize]="totalFontSize()" [style.lineHeight]="totalFontSize()">/</span>
          <span class="self-end" [style.fontSize]="totalFontSize()" [style.lineHeight]="totalFontSize()">
            {{ total()! | numberSuffix }}
          </span>
        </div>

        @if (unit()) {
          <span class="text-xs">{{ unit() }}</span>
        }
      </div>
    }
  </div>

  <div class="flex gap-2 items-center justify-start">
    @if (calculatedLabelIcon()) {
      <app-icon [src]="calculatedLabelIcon()" [size]="16" />
    }

    @if (calculatedLabel()) {
      <span [style.fontSize]="labelFontSize()">{{ calculatedLabel() }}</span>
    }
  </div>
</div>
